import { type IImage } from '@custom/shared/types'

export const trustedByLogos = [
  {
    path: '/trusted-by-logos/trustedby-logo-openai.svg',
    width: 228,
    height: 80,
    alt: 'OpenAI',
  },
  {
    path: '/trusted-by-logos/trustedby-logo-figma.svg',
    width: 228,
    height: 80,
    alt: 'Figma',
  },
  {
    path: '/trusted-by-logos/trustedby-logo-hubspot.svg',
    width: 228,
    height: 80,
    alt: 'HubSpot',
  },
  {
    path: '/trusted-by-logos/trustedby-logo-doordash.svg',
    width: 228,
    height: 80,
    alt: 'Doordash',
  },
  {
    path: '/trusted-by-logos/trustedby-logo-expensify.svg',
    width: 228,
    height: 80,
    alt: 'Expensify',
  },
  {
    path: '/trusted-by-logos/trustedby-logo-eventbrite.svg',
    width: 228,
    height: 80,
    alt: 'Eventbrite',
  },
  {
    path: '/trusted-by-logos/trustedby-logo-zoom.svg',
    width: 228,
    height: 80,
    alt: 'Zoom',
  },
  {
    path: '/trusted-by-logos/trustedby-logo-rivian.svg',
    width: 228,
    height: 80,
    alt: 'Rivian',
  },
  {
    path: '/trusted-by-logos/trustedby-logo-zapier.svg',
    width: 228,
    height: 80,
    alt: 'Zapier',
  },
  {
    path: '/trusted-by-logos/trustedby-logo-brex.svg',
    width: 228,
    height: 80,
    alt: 'Brex',
  },
  {
    path: '/trusted-by-logos/trustedby-logo-atlassian.svg',
    width: 228,
    height: 80,
    alt: 'Atlassian',
  },
  {
    path: '/trusted-by-logos/trustedby-logo-ted.svg',
    width: 228,
    height: 80,
    alt: 'Ted',
  },
]

export const homepageHeroPersonImages: IImage[] = [
  {
    path: '//images.ctfassets.net/vwfkeyj6n9ac/5638budzR16gFR9CjmQwf6/4254a1638f76a23f30e1119022e76671/person-1.webp',
    width: 818,
    height: 660,
  },
  {
    path: '//images.ctfassets.net/vwfkeyj6n9ac/36MwTdlLo2sgpjLQT03flg/ca23ce926259301559af0a0e18c8340b/person-2.webp',
    width: 822,
    height: 660,
  },
  {
    path: '//images.ctfassets.net/vwfkeyj6n9ac/2bQ19TxBnerD47w4UYCH19/88fafdc7fff7c7713cadc8a2dd083cdd/person-3.webp',
    width: 801,
    height: 660,
  },
  {
    path: '//images.ctfassets.net/vwfkeyj6n9ac/4ExmcB9B5akcYJaGyy2eKh/cc5cb3ba20a218281b975fb595892a8a/person-4.webp',
    width: 822,
    height: 660,
  },
  {
    path: '//images.ctfassets.net/vwfkeyj6n9ac/5u1ey2tjoy7mygEusGW2mQ/8c94ef15451a2cad26f32ceba18f1811/person-5.webp',
    width: 822,
    height: 660,
  },
]

/**
 * Deterministically selects a hero person image based on a server-generated seed.
 * This ensures the same image is selected server-side and client-side,
 * avoiding hydration mismatches while providing variety between requests.
 */
export function getRandomHeroPerson(heroImageSeed: number): IImage {
  const index = heroImageSeed % homepageHeroPersonImages.length
  return homepageHeroPersonImages[index]
}
